import { useEffect, useState } from 'react'
import { config } from 'config'

export const useDebouncedValue = <T>(
  value: T,
  time = config.DEFAULT_DEBOUNCE_TIMEOUT
) => {
  const [debouncedValue, setDebouncedValue] = useState(value)
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedValue(value)
    }, time)

    return () => {
      clearTimeout(timeout)
    }
  }, [value, time])

  return debouncedValue
}

export const useTableHeader = (
  search: string,
  onSearch: (value: string) => any
) => {
  const [searchValue, setSearchValue] = useState<string>('')
  const [prevDebouncedSearch, setPrevDebouncedSearch] = useState<string>('')
  const debouncedSearch = useDebouncedValue(searchValue.trim().toLowerCase())

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
  }

  const handleClear = () => {
    setSearchValue('')
  }

  useEffect(() => {
    if (!search) {
      setSearchValue('')
    }
  }, [search])

  useEffect(() => {
    if (!onSearch) return
    const wasSearchCleared =
      prevDebouncedSearch.length >= config.SEARCH_MIN_CHARACTERS &&
      !debouncedSearch.length
    if (
      debouncedSearch.length >= config.SEARCH_MIN_CHARACTERS ||
      wasSearchCleared
    ) {
      onSearch(debouncedSearch)
    }
    setPrevDebouncedSearch(debouncedSearch)
  }, [debouncedSearch, onSearch, prevDebouncedSearch])

  return {
    search: {
      handleClear,
      value: searchValue,
      onChange: handleSearch,
    },
  }
}
